HTMLImageElement.prototype.isLoaded = async function () {
  return new Promise(resolve => {
    const img = new Image()
    if (!this.attributes.src) return resolve()
    img.src = this.attributes.src.value
    img.onload = resolve
    img.onerror = resolve
    let time = 0
    const interval = setInterval(() => {
      time++
      if (time >= 3) {
        clearInterval(interval)
        resolve
      }
    }, 1000)
  })
}

// Replaces old className (or classNames, if array is given) with new className (or classNames, if array is given)

DOMTokenList.prototype.replace = function (oldName, newName) {
  if (Array.isArray(oldName)) this.remove(...oldName)
  else this.remove(oldName)

  if (Array.isArray(newName)) this.add(...newName)
  else this.add(newName)
}
